var _desc, _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontFlavoredWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 440",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Flavored bottled water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A bottle of purple flavored water with a small flavor powder packet pouring into it.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottle",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d9c2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b99cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleWater",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8b4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a855f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e22ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "packet",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fb923c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec4899"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 9,
    stdDeviation: 8,
    floodColor: "#312e81",
    floodOpacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 440,
    fill: "#fbf7ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 30h68v52c0 12 6 24 16 32 24 19 39 49 39 82v176c0 32-26 58-58 58h-62c-32 0-58-26-58-58V196c0-33 15-63 39-82 10-8 16-20 16-32V30z",
    fill: "url(#bottle)",
    stroke: "#9b7cf0",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 10,
    width: 84,
    height: 43,
    rx: 11,
    fill: "#7c3aed",
    stroke: "#5b21b6",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 216h152v98H88z",
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 314h152v30H88z",
    fill: "#5b21b6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 267,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 800,
    fill: "#ffffff"
  }, "FLAVOR"), /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 296,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 21,
    fontWeight: 700,
    fill: "#f5d0fe"
  }, "WATER"), /*#__PURE__*/React.createElement("path", {
    d: "M88 184c30 17 49 17 79 0s50-17 70 0v177c0 26-21 47-47 47h-54c-26 0-47-21-47-47V184z",
    fill: "url(#purpleWater)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 122c-17 18-25 40-25 66v181c0 23 18 42 41 42",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    opacity: 0.62,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 202c39 23 96 22 144-2",
    fill: "none",
    stroke: "#f0abfc",
    strokeWidth: 7,
    opacity: 0.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(223 42) rotate(19)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h82l14 118H-14z",
    fill: "url(#packet)",
    stroke: "#9f1239",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15h64M14 96h62",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 57,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 800,
    fill: "#ffffff"
  }, "GRAPE"), /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 78,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff7ed"
  }, "MIX"), /*#__PURE__*/React.createElement("path", {
    d: "M12 117c14 25 28 44 44 58",
    fill: "none",
    stroke: "#8b5cf6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeDasharray: "3 14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 184,
    r: 6,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 166,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 159,
    r: 4,
    fill: "#c084fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontFlavoredWater);
export default __webpack_public_path__ + "static/media/product_storefront_flavored_water.f06e63614a83767ae8a33a4216160c7b.svg";
export { ForwardRef as ReactComponent };